
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Paper,
  Stack,
  Grid,
  Typography,
} from "@mui/material";
import { useState, useCallback } from "react";
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { CustomAutocompleteArrStringNoForm } from "@/shared/components/ui";
import TrasladoForm from "../OrdenServicioTraslado/TrasladoForm";

import { useLocalidad } from "@/shared/hooks/useLocalidad";
import { useForm } from "react-hook-form";
import { gridSizeMdLg12, handleErrorForm, obtenerUbicacion, toHour, useLoaders, useMapComponent } from "@/shared";
import useSelectDateTimerPreScheduling from "@/erp/sale/component/calendario-preagendamiento-venta/useSelectDateTimerPreScheduling.store";
import { toast } from "react-toastify";
import { postPoligono } from "@/shared/actions/erp";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useFetchPostOrdenServicio } from "@/shared/actions";
import { Contrato, Sector } from "@/shared/interfaces";
import { yupResolver } from "@hookform/resolvers/yup";
import { ordenServicioTrasladoSchema } from "@/erp/orden-servicio/orden-servicio-traslado/utils/orden-servicio-traslado.schema";
import { useAuthStore } from "@/store/auth";
import OrdenServicioList from "@/erp/orden-servicio/orden-servicio/components/table-orden-servicio/TableOrdenServicioCustom";
import { TipoOrdenServicioEnumChoice } from "@/erp/orden-servicio/orden-servicio/utils/choice.orden-servicio";
import { useDescuentoTrasladoFibra } from "@/shared/hooks/useDescuentoTrasladoFibra";

const OptionsTipoOrdenServicio = [
  TipoOrdenServicioEnumChoice.TODOS,
  TipoOrdenServicioEnumChoice.TRASLADO,
  TipoOrdenServicioEnumChoice.RAZON_SOCIAL,
]

type FormTraslado = {
  coordenada: string
  direccion: string
  provincia: string
  ciudad: string
  sector: string
  zona: string
  parroquia: string
  tipo_orden_servicio: string
  coordenadas: string
  latitud: string
  longitud: string
  pais: string
  provincia_nombre: string
  ciudad_nombre: string
  zona_nombre: string
  pais_id: string
  zona_id: string
  ciudad_id: string
  provincia_id: string
  parroquia_id: string
  sector_id: string
}

type TabOrdenServicioProps = {
  contrato: Contrato | null;
  cliente?: any;
  saldoPendiente?: string | number;
  fibraPoints?: string | number;
}

export default function TabOrdenServicio({
  contrato,
  cliente,
  saldoPendiente,
  fibraPoints,
}: TabOrdenServicioProps) {

  const [openModal, setOpenModal] = useState(false);

  const [tipoForm, setTipoForm] = useState<TipoOrdenServicioEnumChoice>(TipoOrdenServicioEnumChoice.TRASLADO);

  const [tipoOptions, setTipoOptions] = useState<TipoOrdenServicioEnumChoice>(TipoOrdenServicioEnumChoice.TODOS)

  //const [contrato, setContrato] = useState<Contrato | null>(null)
  const [existeCobertura, setExisteCobertura] = useState(false);
  const [modalMapa, setModalMapa] = useState(false);

  // fetch
  const {
    mutateAsync: postOrdenServicioAsync,
    isPending: isPostingOrdenServicio
  } = useFetchPostOrdenServicio()

  // form
  const form = useForm<FormTraslado>({
    resolver: yupResolver(ordenServicioTrasladoSchema as any),
    defaultValues: {
      tipo_orden_servicio: 'TRASLADO',
    },
  });

  const {
    reset,
    handleSubmit
  } = form;


  const {
    dataSector,
    isLoadingSector
  } = useLocalidad({
    form: form as any,
    cobertura: true,
  });

  const {
    latLng,
    setLatLng,
    Map: MapComponent,
    napsByCity,
    isLoadingNapsByCity,
    setCurrentCoordenadas,
  } = useMapComponent({
    form,
    currentCity: "",
    coordenadasCliente: "",
    enabledFetchNaps: true,
    canUpdateLatLong: true,
    async onChangeMarker(value) {
      if (!value) return;
      handleVerificarCoordenada(value.lat.toString(), value.lng.toString());
    },
  });

  const user = useAuthStore(s => s.user);
  const { descuento: descuentoFibra } = useDescuentoTrasladoFibra();
  // Planificador (Técnico/Fecha/Hora) elegido en el modal.
  const selectFloat = useSelectDateTimerPreScheduling(s => s.selectFloat);
  const selectDate = useSelectDateTimerPreScheduling(s => s.selectDate);
  const slot = useSelectDateTimerPreScheduling(s => s.slot);

  const onSubmit = async (value: any) => {

    // El traslado se agenda desde acá (va directo al técnico): se exige flota +
    // fecha + hora del planificador.
    if (!selectFloat || !slot?.hora || !selectDate) {
      toast.error("Seleccioná técnico, fecha y hora disponible para agendar el traslado.");
      return;
    }
    const fechaTraslado = `${selectDate.format("YYYY-MM-DD")}T${toHour(slot.hora).padStart(5, "0")}:00`;

    // Opciones de recaudación: exactamente una (ni ambas ni ninguna).
    // Con FibraPoints la recaudación NO aplica -> no se valida.
    const recaudacionTecnico = !!value.recaudacion_tecnico;
    const cargoAFactura = !!value.cargo_a_factura;
    if (!value.traslado_por_fibrapoints && recaudacionTecnico === cargoAFactura) {
      toast.error(
        "Seleccioná una opción de recaudación: ¿Recaudación técnico? o ¿Cargo a factura? (solo una)."
      );
      return;
    }

    const send = {
      tipo_orden_servicio: value.tipo_orden_servicio,
      user_create: user?.username || "N/A",
      contrato: contrato?.numero_referencia,
      id_instalacion_externa: contrato?.id_instalacion || -9999999,
      traslado: {
        pais: value.pais_id,
        provincia: value.provincia_id,
        ciudad: value.ciudad_id,
        parroquia: value.sector_id,
        zona: value.zona_id,
        sector: value.sector_id,
        direccion: value.direccion,
        coordenada: value.coordenadas,
        // Agendamiento + detalle de valores
        flota: selectFloat,
        fecha_traslado: fechaTraslado,
        observaciones: value.observaciones || "",
        valor_traslado: value.valor_traslado ?? "23.00",
        traslado_por_fibrapoints: !!value.traslado_por_fibrapoints,
        recaudacion_tecnico: recaudacionTecnico,
        cargo_a_factura: cargoAFactura,
        // Datos para el cobro de rubros a Softnet (se envía al finalizar el traslado):
        // - id_contrato_softnet = código del contrato (SN-xxxx) sin el prefijo "SN-".
        // - puntos_antes_canje / puntos_canjeados: solo aplican si es FibraPoints.
        // - meses_pago: solo aplica si es Cargo a factura (1 = una cuota; más = diferido).
        id_contrato_softnet: (contrato?.codigo || "").replace(/^SN-?/i, ""),
        // Puntos SOLO cuando es FibraPoints (así el back infiere tipo_pago=FIBRAPOINTS).
        puntos_antes_canje: value.traslado_por_fibrapoints ? (Number(fibraPoints) || 0) : null,
        puntos_canjeados: value.traslado_por_fibrapoints ? (Number(descuentoFibra) || 0) : null,
        // Meses a diferir SOLO cuando es Cargo a factura (default 1).
        meses_pago: cargoAFactura ? (Number(value.meses_pago) || 1) : null,
        // Otros conceptos (catálogo de traslados): el micro los guarda y los
        // reenvía a Django (agendamiento.observaciones.otros_conceptos).
        otros_conceptos: Array.isArray(value.otros_conceptos) ? value.otros_conceptos : [],
      }
    }

    const resp = await postOrdenServicioAsync({
      ...send
    } as any)

    if (resp.code == 201) {
      setModalMapa(false)
      setOpenModal(false)
      setExisteCobertura(false)
      reset({
        tipo_orden_servicio: 'TRASLADO',
      })

    }
  }
  

  // manejar coordenada valida
  const handleCoordenadaValida = (
    value: string,
    valid: boolean | undefined
  ) => {
    if (!valid || !value) return;
    let coord = value.split(",");
    setLatLng({ lat: +coord[0], lng: +coord[1] });
    setCurrentCoordenadas(value);
    handleVerificarCoordenada(coord[0], coord[1]);
    reset({
      ...form.getValues(),
    });
  };

  // obtener ubicacion actual por GPS

  const handleApiUbicacioActual = async () => {
    try {
      const coordenadasApi = await obtenerUbicacion();
      const { latitude, longitude } = coordenadasApi;
      setLatLng({
        lat: latitude,
        lng: longitude,
      });
      setCurrentCoordenadas(`${latitude},${longitude}`);
      reset({
        ...form.getValues(),
        coordenadas: `${latitude},${longitude}`,
        latitud: latitude.toString(),
        longitud: longitude.toString(),
      });

      handleVerificarCoordenada(latitude.toString(), longitude.toString());
    } catch (error) {
      console.log(error, "error");
    } finally {
    }
  };

  // verificar si existe cobertura acorde a las coordendas ingresadas

  const handleVerificarCoordenada = useCallback(
    async (lat: string, lng: string) => {
      try {
        const resp = await postPoligono({
          latitud: lat,
          longitud: lng,
        });

        reset({
          ...form.getValues(),
          pais: resp.data.pais_data?.codigo,
          zona: resp.data.codigo,
          ciudad: resp.data.ciudad_data?.codigo,
          provincia: resp.data.provincia_data?.codigo,
          provincia_nombre: resp.data.provincia_data?.nombre,
          ciudad_nombre: resp.data.ciudad_data?.nombre,
          zona_nombre: resp.data.nombre,

          // id's
          pais_id: resp.data.pais_data?.id_pais,
          zona_id: resp.data.id_zona,
          ciudad_id: resp.data.ciudad_data?.id_ciudad,
          provincia_id: resp.data.provincia_data?.id_provincia,
        });

        setExisteCobertura(true);
      } catch (error) {
        setExisteCobertura(false);
        reset({
          ...form.getValues(),
          pais: "",
          zona: "",
          ciudad: "",
          provincia: "",
          zona_nombre: "",
          provincia_nombre: "",
          ciudad_nombre: "",
        });
      }
    },
    []
  );

  const handleSelectSector = async (value: Sector) => {
    // TODO: Implement sector selection logic
    console.log("Selected sector:", value);

    reset({
      ...form.getValues(),
      parroquia: value.codigo,
      sector: value.codigo,
      parroquia_id: value.id_sector,
      sector_id: value.id_sector
    });
  }

  const handleResetForm = () => {
    setOpenModal(false)
    setExisteCobertura(false)
    // Usamos el miembro del enum (no el string literal) porque setTipoForm
    // esta tipado a TipoOrdenServicioEnumChoice. En runtime es exactamente
    // 'TRASLADO' igual.
    setTipoForm(TipoOrdenServicioEnumChoice.TRASLADO)
    setModalMapa(false)
    reset({
      tipo_orden_servicio: 'TRASLADO'
    })
  }

  useLoaders(
    isPostingOrdenServicio ||
    isLoadingNapsByCity ||
    isLoadingSector
  )

  return (
    <>
      <Paper elevation={0} sx={{ p: 2, border: '1px solid', borderColor: 'grey.200', borderRadius: 2 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
          <ElectricalServicesIcon color="primary" fontSize="small" />
          <Typography variant="subtitle1" fontWeight={700} sx={{ flexGrow: 1 }}>
            Orden Servicio
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center" width={'300px'}>
            <Box sx={{ flex: 1 }}>
              <CustomAutocompleteArrStringNoForm
                label="Tipo"
                options={OptionsTipoOrdenServicio}
                defaultValue={TipoOrdenServicioEnumChoice.TODOS}
                disableClearable
                size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sizeAutocomplete="small"
                onChangeValue={(value)=>{
                  setTipoOptions(value)
                }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Button fullWidth variant="contained" size="small" startIcon={<AddCircleOutlineIcon />} sx={{ whiteSpace: 'nowrap' }} onClick={() => setOpenModal(true)}>
                Crear
              </Button>
            </Box>
          </Stack>
        </Stack>

        <Grid container>
          <Grid {...gridSizeMdLg12}>

            <OrdenServicioList
              tipo_orden_servicio={tipoOptions}
              tipo_orden_servicio__exclude_in={`${TipoOrdenServicioEnumChoice.VISITA}`}
              contrato={contrato?.numero_referencia || ''}
            />

            {/* <TableOrdenServicio
              tipo_orden_servicio__exclude_in="VISITA"
              tipo_orden_servicio="TRASLADO"
              contrato={contrato?.numero_referencia || ''}
            /> */}
          </Grid>
        </Grid>
      </Paper>


      <Dialog open={openModal} onClose={() => {
        setOpenModal(false)
        handleResetForm()
      }} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Typography variant="subtitle1" fontWeight={700}>🌐 Nueva Orden de Servicio</Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>
        

          {
            tipoForm === TipoOrdenServicioEnumChoice.TRASLADO && (
              <Box sx={{ pt: 1 }}>
                <TrasladoForm
                  contrato={contrato}
                  cliente={cliente}
                  saldoPendiente={saldoPendiente}
                  fibraPoints={fibraPoints}
                  descuentoFibra={descuentoFibra}
                  form={form}
                  existeCobertura={existeCobertura}
                  dataSector={dataSector}
                  isLoadingSector={isLoadingSector}
                  napsByCity={napsByCity}
                  isLoadingNapsByCity={isLoadingNapsByCity}
                  onCoordenadaValida={handleCoordenadaValida}
                  onSelectSector={handleSelectSector}
                  onOpenMapa={() => setModalMapa(true)}
                  onObtenerUbicacionActual={handleApiUbicacioActual}
                />
              </Box>
            )
            
          }
          
        </DialogContent>
        <Divider />
        {/* Acciones del modal. OJO: este bloque se perdió en el merge con prod del
            29-sep (prod tampoco lo trae); sin él no hay forma de guardar la orden.
            Al volver a mezclar prod, conservar este bloque. */}
        <DialogActions sx={{ px: 2, py: 1.5 }}>
          <Button variant="outlined" size="small" disabled={isPostingOrdenServicio} onClick={() => {
            setOpenModal(false)
            handleResetForm()
          }}>Cancelar</Button>
          <Button variant="contained" size="small" disabled={isPostingOrdenServicio} onClick={handleSubmit(onSubmit, (e) => {
            handleErrorForm(e);
          })}>{isPostingOrdenServicio ? "Guardando…" : "Guardar"}</Button>
        </DialogActions>
      </Dialog>

      {modalMapa && (
        <ScrollableDialogProps
          open={modalMapa}
          title={`Mapa`}
          onCloseIcon={() => setModalMapa(false)}
          contentNode={
            <MapComponent
              key={"mapa-agenda"}
              coordenadas={latLng}
              napsByCity={napsByCity || []}
              setLatLng={setLatLng}
              canDragMarker
            />
          }
        />
      )}
      {/* ModalInfoTrasladoLocalidad se monta ahora dentro de OrdenServicioList
          (componente compartido) para que "Ver detalles" funcione también en
          /operaciones/ordenes-servicio. No se monta aquí para evitar duplicado. */}
    </>
  )
}

